import { useTranslation } from 'react-i18next';

export const useGetPerformanceSearchResults = () => {
  const { t } = useTranslation();

  const getSearchResults = (rowData, totalData, id) => {
    if (Array.isArray(rowData) && rowData.length > 0)
      return [
        ...rowData.map(row => ({
          ...row,
          id: row[id],
        })),
        {
          ...totalData,
          id: 'total',
          displayInfoTitle: t(
            'page.loyaltyPerformanceReport.tabs.locationLoyaltyPerformance.grid.totalRow.label',
          ),
        },
      ];
    return [];
  };

  return { getSearchResults };
};
